import React, { useState, useEffect } from "react";
import { Col, Row, Image, Button, Divider, Card } from "antd";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import ReactPlayer from "react-player";
import { LeftOutlined } from "@ant-design/icons";
import "antd/dist/antd.compact.css";
import { PDFObject } from 'react-pdfobject'

import DetailCard from "./DetailCard";
import CustomScrollbars from '../../utils/CustomScrollbars'


const ProductPreview = (props) => {
   const [isPdf, setIsPdf] = useState(false);
   const [pdfUrl, setPdfUrl] = useState("");
   const [selectedProduct, setSelectedProduct] = useState({});
   const [numPages, setNumPages] = useState(0);
   
   useEffect(() => {
      setSelectedProduct(props.data)
   }, [props.data])

   const handleProducData = item => {
      setSelectedProduct(item)
   }

   const getLinksResource = () => {
      let result = [];
      let linksArray = [];
      _get(selectedProduct, "array_of_resources", []).map(
         ({ type, label, url }, index) => {
            let resourceType = type.toLowerCase();
            if (resourceType === "link") {
               linksArray.push(
                  <Row key={index}>
                     <Col key={index} span={24}>
                        <a href={url.includes("http") ? url : "https://" + url} target="_blank">
                           <div style={{
                              background:
                                 "rgb(143, 34, 25)",
                              color: "#fff"
                           }} className='gx-text-center align-center gx-p-1 gx-m-1'>
                              {label}
                           </div>
                        </a>
                     </Col>
                  </Row>
               );
            }
         }
      );
      if (!_isEmpty(linksArray)) {
         result = (
            <div>
               <Divider orientation="left">
                  <h2>Links</h2>
               </Divider>
               {linksArray}
            </div>
         );
      }
      return result;
   };

   const onDocumentLoadSuccess = (numPage) => {
      setNumPages(numPage.numPages);
   };
   const openPdf = (pdf) => {
      setIsPdf(true);
      setPdfUrl(pdf);
   };

   const getPdfResource = () => {
      let result = [];
      let pdfArray = [];
      _get(selectedProduct, "array_of_resources", []).map(
         ({ type, label, url }, index) => {
            let resourceType = type.toLowerCase();
            if (resourceType === "pdf") {
               pdfArray.push(
                  <Col key={index} xl={8} lg={12} md={12} sm={12} xs={24}>
                     <span className="gx-widget-badge-top-left-product badgeHeader">New PDF</span>
                     <DetailCard
                        key={index}
                        pdf={true}
                        documentUrl={url}
                        title={label}
                        onClick={() => openPdf(url)}
                        onLoadSuccess={onDocumentLoadSuccess}
                        config={{}}
                     />
                  </Col>
               );
            }
         }
      );
      if (!_isEmpty(pdfArray)) {
         result = (
            <Row>
               <Divider orientation="left">
                  <h2>PDFs</h2>
               </Divider>
               {pdfArray}
            </Row>
         );
      }
      return result;
   };
   const getVideoResource = () => {
      let result = null;
      let videosArray = [];
      _get(selectedProduct, "array_of_resources", []).map(
         ({ type, url, label }, index) => {
            let resourceType = type.toLowerCase();
            let videos = ["video", "youtube"];
            if (videos.includes(resourceType)) {
               videosArray.push(
                  <Row key={index} gutter={[8, 16]}>
                     <Col key={index} xl={20} lg={20} md={20} sm={24} xs={24}>
                        <Card className="gx-card-widget" style={{ borderRadius: 6 }}>
                           <div style={{ height: 30 }}></div>
                           <h3 className="gx-mb-3 gx-text-left">{label ? label : `Video ${index + 1}`}</h3>
                           <div className="video-container">
                              <ReactPlayer
                                 className="react-player"
                                 url={url}
                                 height="80%"
                                 width="80%"
                                 controls
                              />
                           </div>
                        </Card>
                     </Col>
                  </Row>
               );
            }
         }
      );
      if (!_isEmpty(videosArray)) {
         result = (
            <div>
               <Divider orientation="left">
                  <h2>Videos</h2>
               </Divider>
               {videosArray}
            </div>
         );
      }
      return result;
   };

   const otherProductsFN = (selectedProduct) => {
      return <div>
         <Card className='ant-card ant-card-bordered gx-card-widget gx-card-full gx-mx-3' onClick={() => setIsPdf(false)}>
            <h4 className="gx-text-primary gx-text-capitalize gx-m-3 app-text-color">
               <i className="icon icon-profile gx-mr-3" />
               Other products
            </h4>
            <CustomScrollbars autoHeight autoHeightMax={!_isEmpty(selectedProduct) ? 700 : 1000} >
               <Row justify="center" className='gx-mt-3'>
                  {props?.exhibitor?.media.products.filter(val => val.id !== selectedProduct.id).map((item, index) => {
                     return <Col xl={20} lg={20} md={20} sm={24} xs={20} className='gx-mt-3' onClick={() => handleProducData(item)}>
                        <div>
                           <DetailCard
                              key={index}
                              imageSrc={item.data.feature_image}
                              title={item.data.name}
                              config={props.config}
                              isDetail={true}
                           />
                        </div>
                     </Col>
                  })}
               </Row>
            </CustomScrollbars>
         </Card>
      </div>
   }
   return (
      <div>
         {!_isEmpty(selectedProduct) && (
            <>
               <Row>
                  <Col span={24}>
                     <div className="exhibHomeBack" >
                        <span className='pdfBack gx-pointer' onClick={() => props.setProductPreview({ isProductPrev: false })}>
                           <LeftOutlined />
                           Back
                        </span>
                     </div>
                  </Col>
               </Row>
               <Row>
                  <Col xl={16} lg={16} md={23} sm={24} xs={23}>
                     {!isPdf && (
                        <Card className='gx-card-widget gx-my-3 gx-ml-5 gx-mr-1'>
                           <Row>
                              {selectedProduct?.data?.new_product && <span className="gx-widget-badge-new gx-widget-badge-top-left badgeHeader">
                                 New product
                              </span>}
                           </Row>
                           <Row className="gx-mt-5">
                              <Col span={20}>
                                 <h1>{selectedProduct.data.name}</h1>
                              </Col>
                           </Row>

                           <Row className="gx-py-3">
                              <Col xl={15} md={15} xs={10}>
                                 <div className="product-image-container">
                                    <Image
                                       src={selectedProduct.data.feature_image}
                                    />
                                 </div>
                              </Col>
                              <Col xl={9} md={9} xs={6}>
                                 <img
                                    src={selectedProduct.data.CompLogo}
                                 />
                                 <h3 className="gx-mt-2">
                                    {selectedProduct.data.Companyname}
                                 </h3>
                                 <Button
                                    style={{
                                       backgroundColor: "rgb(143, 34, 25)",
                                       color: "white",
                                    }}
                                    onClick={() => props.setProductPreview({ isProductPrev: false })}
                                 >
                                    {" "}
                                    Visit Booth
                                 </Button>
                              </Col>
                           </Row>
                           <Row className="gx-mt-4">
                              <Col span={24}>
                                 <div
                                    dangerouslySetInnerHTML={{
                                       __html: selectedProduct.data.description,
                                    }}
                                 />
                              </Col>
                           </Row>
                           <Row>
                              <Col span={24}>{getLinksResource()}</Col>
                           </Row>
                           <Row>
                              <Col span={24}>{getPdfResource()}</Col>
                           </Row>
                           <Row>
                              <Col span={24}>{getVideoResource()}</Col>
                           </Row>
                        </Card>
                     )}
                     {isPdf && (
                        <PDFObject url={pdfUrl}
                           height={"60vh"}
                        />
                     )}
                  </Col>
                  <Col xl={8} lg={8} md={23} sm={23} xs={23} >
                     <Row className='gx-mt-4'>
                        <Col xl={24} lg={23} md={23} sm={23} xs={24} >
                           {otherProductsFN(selectedProduct)}
                        </Col>
                     </Row>
                  </Col>
               </Row>
            </>)}
      </div>
   )
};

export default ProductPreview;
